import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ServiceWorkerModule, SwUpdate } from '@angular/service-worker';

import { ToastrModule } from 'ngx-toastr';
import {
  MatDatepickerModule, MatFormFieldModule, MatNativeDateModule,
  MatInputModule, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDateFormats
} from '@angular/material';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

//Routing
import { AppRoutingModule } from './app-routing.module';
import { StatsRoutingModule } from './modules/pages/stats/stats.routing';
import { DocPreviewRoutingModule } from './modules/pages/docpreview/doc-preview.routing';
import { TemplatesRoutingModule } from './modules/pages/templates/templates.routing';
import { InvoiceRoutingModule } from './modules/pages/invoice/invoice.routing';

//Modules
import { AuthModule } from './modules/auth/auth.module';
import { InvoiceModule } from './modules/pages/invoice/invoice.module';
import { StatsModule } from './modules/pages/stats/stats.module';
import { DocPreviewModule } from './modules/pages/docpreview/doc-preview.module';
import { TemplatesModule } from './modules/pages/templates/templates.module';


import { AuthService } from './core/services/auth.service';
import { InvoiceService } from './core/services/invoice.service';
import { TemplatesService } from './core/services/templates.service';
import { PwaService } from './core/services/pwa.service';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { NavBarComponent } from './core/components/nav-bar/nav-bar.component';
import { PagesComponent } from './modules/pages/pages.component';



registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    PagesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StatsRoutingModule,
    DocPreviewRoutingModule,
    TemplatesRoutingModule,
    InvoiceRoutingModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AuthModule,
    InvoiceModule,
    StatsModule,
    DocPreviewModule,
    TemplatesModule
  ],
  providers: [
    AuthService,
    InvoiceService,
    TemplatesService,
    PwaService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
